module.exports = __webpack_public_path__ + "static/img/member05.8e98b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member05.png
// module id = qrtg
// module chunks = 0